import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import UserMiddleware from "./Middleware/UserMiddleware";

export default function App() {
  const router = createBrowserRouter([
    { path: "/", element: <UserMiddleware/> },
    { path: "/:id", element: <UserMiddleware/> },
    { path: "/:id/admin", element: <UserMiddleware/> }
  ])
  return <RouterProvider router={router}/>
}
